import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../../../reducer/CombineReducer";
import { CreateSchedule } from "../CreateSchedule/CreateSchedule.logic";
import { CreateScheduleSlice } from "../CreateSchedule/redux";
import { initialState } from "../CreateSchedule/redux/Slice";
import { SchedulingModes } from "../CreateSchedule/redux/Types";
import { SchedulingListView } from "./SchedulingList.view";

// Responsible for rendering schedule list
export const ScheduleList: React.FC = () => {
  const dispatch = useDispatch();
  const scheduling = useSelector((state: IRootState) => state.scheduling);
  const onAddingNewSchedule = (): void => {
    dispatch(CreateScheduleSlice.actions.setScheduleListPage(true));
    dispatch(CreateScheduleSlice.actions.seSchedulingMode(SchedulingModes.CREATE));
    dispatch(CreateScheduleSlice.actions.setIsEndByEnabled(true));
    dispatch(CreateScheduleSlice.actions.setIsEndAfterEnabled(false));
    dispatch(CreateScheduleSlice.actions.setNewScheduleDetails(initialState.schedulingDetails));
  };

  // To cleanup on unmount
  React.  useEffect(() => {
    return (): void => {
      dispatch(CreateScheduleSlice.actions.setScheduleListPage(false));
    };
  }, []);

  return (
    <>
      {!scheduling?.isScheduleListPage
        &&
        <SchedulingListView
          onClick={onAddingNewSchedule}
        />
        ||
        <CreateSchedule />}
    </>
  );
};
